import mapboxgl from 'mapbox-gl';
import maplibregl from 'maplibre-gl';

export default {
    data() {
        return {
            currentPopup: null,
            startMarker: null,
            endMarker: null,
            isRouteHidden: false
        };
    },
    methods: {
        addRouteSource(route) {
            const sourceId = `route-${route.id}`;
            this.mySmartMap.addSource(sourceId, {
                type: 'geojson',
                data: {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'MultiLineString',
                        coordinates: route.coordinates
                    }
                },
                lineMetrics: true
            });
        },
        addRouteLayer(route) {
            const sourceId = `route-${route.id}`;

            this.mySmartMap.addLayer({
                id: sourceId + '-outline',
                type: 'line',
                source: sourceId,
                paint: {
                    'line-color': '#ffffff',
                    'line-width': parseFloat(route.line_width) + 4,
                    'line-opacity': 1
                }
            });

            this.mySmartMap.addLayer({
                id: sourceId,
                type: 'line',
                source: sourceId,
                paint: {
                    'line-color': route.line_color,
                    'line-width': parseFloat(route.line_width)
                }
            });

            if (!this.mySmartMap.getSource("tp-line")) {
                this.mySmartMap.addSource("tp-line", {
                    type: "geojson",
                    data: {
                        type: 'FeatureCollection',
                        features: [sourceId]
                    },
                    lineMetrics: true
                });
            }

            this.mySmartMap.addLayer({
                id: "tp-line-line",
                type: "line",
                source: sourceId,
                paint: {
                    "line-color": "rgba(0,0,0,0)",
                    "line-width": parseFloat(route.line_width) + 2,
                    "line-opacity": 1
                }
            });
        },
        addAnimation(route) {
            let startTime;
            const duration = 3600;
            const pauseDuration = 4400;
            let animationId;
            this.isAnimating = true;
        
            const animate = () => {
                if (!this.isAnimating) return;
        
                const currentTime = performance.now();
                const elapsedTime = currentTime - startTime;
                const animationPhase = elapsedTime / duration;
                const animationPhaseDisplay = animationPhase.toFixed(2);
                $("#animation-phase").text(animationPhaseDisplay);
        
                if (this.mySmartMap.getLayer("tp-line-line")) {
                    this.mySmartMap.setPaintProperty("tp-line-line",
                        'line-gradient', [
                            "interpolate",
                            ["linear"],
                            ["line-progress"],
                            animationPhase - 0.15, "rgba(0, 0, 0, 0)",
                            animationPhase, "#fff",
                            animationPhase + 0.15, "rgba(0, 0, 0, 0)"
                        ]);
                }
        
                if (animationPhase > 1) {
                    this.isAnimating = false;
        
                    setTimeout(() => {
                        startTime = performance.now();
                        this.isAnimating = true;
                        animate();
                    }, pauseDuration);
                } else {
                    animationId = window.requestAnimationFrame(animate);
                }
            };
        
            startTime = performance.now();
            animate();
        },
        addCircle(route) {
            var lineString = {
                type: "Feature",
                geometry: {
                    type: "MultiLineString",
                    coordinates: route.coordinates
                }
            };
            var startPoint = {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: route.coordinates[0][0]
                },
                properties: {
                    order: 'start'
                }
            };

            var endGroup = route.coordinates[route.coordinates.length - 1];
            var endPoint = {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: endGroup[endGroup.length - 1]
                },
                properties: {
                    order: 'end'
                }
            };

            const sourceId = `route-${route.id}`;
            this.mySmartMap.addLayer({
                id: 'circle-flag-for-' + sourceId,
                type: 'circle',
                source: sourceId,
                paint: {
                    'circle-radius': 8,
                    'circle-stroke-width': 2,
                    'circle-stroke-color': [
                        'case',
                        ['==', ['geometry-type'], 'Point'],
                        ['case', ['==', ['get', 'order'], 'start'], '#fff', '#fff'],
                        '#000'
                    ],
                    'circle-color': [
                        'case',
                        ['==', ['geometry-type'], 'Point'],
                        ['case',
                            ['==', ['get', 'order'], 'start'], '#007fff', '#007fff'
                        ],
                        '#FF0'
                    ]
                },
                filter: ['in', '$type', 'Point']
            });

            this.mySmartMap.getSource(sourceId).setData({
                type: 'FeatureCollection',
                features: [lineString, startPoint, endPoint],
            });
        },
        addStartPoint(route) {
            const startPoint = route.coordinates[0][0];

            this.startMarker = new mapboxgl.Marker({
                element: document.createElement('div'),
                anchor: 'bottom'
            });

            this.startMarker.getElement().innerHTML = `
                <div class="map-button start-icon" style="width: 80px; height: 40px;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="40" viewBox="0 0 153.586 302.067">
                        <path d="M182.109,251.74l9.657-67.856,19.482-12.094a9.672,9.672,0,0,0,4.477-9.587l-7.478-52.448c-3.053-20.09-20.811-36.466-39.77-36.839a39.459,39.459,0,1,0-42.879,0c-18.959.375-36.718,16.751-39.781,36.927L78.351,162.2a9.673,9.673,0,0,0,4.476,9.587l19.48,12.094,9.657,67.856s6.739,20.589,13.482,28.44,36.042,7.85,43.031,0S182.109,251.74,182.109,251.74Z" fill="#4646ff" stroke="#fff" stroke-width="16"/>
                </svg>
            `;

            this.startMarker.setLngLat(startPoint)
                .addTo(this.mySmartMap);

            this.startMarker.getElement().style.cursor = 'pointer';

            this.startMarker.getElement().addEventListener('click', () => {
                const popup = new mapboxgl.Popup()
                    .setLngLat(startPoint)
                    .setText('Start Point')
                    .addTo(this.mySmartMap);
            });
        },

        addEndPoint(route) {
            const endGroup = route.coordinates[route.coordinates.length - 1];
            const endPoint = endGroup[endGroup.length - 1];

            this.endMarker = new mapboxgl.Marker({
                element: document.createElement('div'),
                anchor: 'bottom'
            });

            this.endMarker.getElement().innerHTML = `
                <div class="map-button end-icon" style="width: 80px; height: 40px;">
                    <svg fill="#ff6666" width="80px" height="40px" viewBox="0 0 471.098 471.098" xmlns="http://www.w3.org/2000/svg">
                        <path d="M403.288,153.454L111.732,45.741v-21.27C111.732,10.961,100.779,0,87.261,0C73.743,0,62.79,10.961,62.79,24.471v422.156c0,13.51,10.952,24.471,24.471,24.471c13.518,0,24.471-10.961,24.471-24.471V275.555l291.557-107.699c3.012-1.113,5.019-3.981,5.019-7.2C408.307,157.436,406.3,154.57,403.288,153.454z"/>
                    </svg>
                </div>
            `;

            this.endMarker.setLngLat(endPoint)
                .addTo(this.mySmartMap);

            this.endMarker.getElement().style.cursor = 'pointer';

            this.endMarker.getElement().addEventListener('click', () => {
                const popup = new mapboxgl.Popup()
                    .setLngLat(endPoint)
                    .setText('End Point')
                    .addTo(this.mySmartMap);
            });
        },
        showRoute(route) {
            const sourceId = `route-${route.id}`;
            
            this.isRouteHidden = false;
    
            this.mySmartMap.once('moveend', () => {
                if (!this.mySmartMap.getSource(sourceId)) {
                    this.addRouteSource(route);
                }
                if (!this.mySmartMap.getLayer(sourceId)) {
                    this.addRouteLayer(route);
                } else {
                    this.mySmartMap.setLayoutProperty(sourceId, 'visibility', 'visible');
                }
    
                if (route.add_circle_and_flag) {
                    if (!this.mySmartMap.getLayer('circle-flag-for-' + sourceId)) {
                        this.addCircle(route);
                    } else {
                        this.mySmartMap.setLayoutProperty('circle-flag-for-' + sourceId, 'visibility', 'visible');
                    }
                }
    
                // Remove existing popup if any
                if (this.currentPopup) {
                    this.currentPopup.remove();
                }
    
                // Calculate the lowest position for the popup
                let lowestPoint = null;
                let lowestLat = Infinity;
    
                // Find the lowest latitude point
                route.coordinates.forEach(line => {
                    line.forEach(point => {
                        if (point[1] < lowestLat) {
                            lowestLat = point[1];
                            lowestPoint = point;
                        }
                    });
                });
    
                if (!lowestPoint) {
                    console.error('No points found to position the popup.');
                    return;
                }
    
                const [lng, lat] = lowestPoint;
                const popupOffset = [0, -60];
    
                const popup = new mapboxgl.Popup({ closeButton: false, closeOnClick: false, offset: popupOffset });
    
                popup.setLngLat([lng, lat])
                     .setHTML(`
                        <div class="popup-content compact">
                            <div class="bg-base-100 rounded p-2 popup-bg-opacity-80">
                                <h3 class="text-black mb-1 font-bold text-xs break-words text-overflow-wrap">${route.title}</h3>
                                <div class="flex justify-end">
                                    <button class="btn btn-primary rounded-full btn-xs ml-2 btn-circle" id="delete-button-${sourceId}">
                                        <span class="material-symbols-outlined notranslate fill-current">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
                                                <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/>
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    `).addTo(this.mySmartMap);
    
                this.currentPopup = popup;
    
                this.mySmartMap.on('zoom', this.updatePopupVisibility);
                this.mySmartMap.on('move', this.updatePopupVisibility);
    
                popup.getElement().querySelector(`#delete-button-${sourceId}`).addEventListener('click', () => {
                    this.closeDetail();
                    this.hideRoute(route);
                });
            });
        },
        hideRoute(route) {
            const sourceId = `route-${route.id}`;
            
            if (this.isAnimating) {
                this.isAnimating = false;
            }
            
            if (this.mySmartMap.getLayer('tp-line-line')) {
                this.mySmartMap.removeLayer('tp-line-line');
            }
        
            if (this.mySmartMap.getLayer(sourceId)) {
                this.mySmartMap.removeLayer(sourceId);
            }
        
            if (this.mySmartMap.getLayer(sourceId + '-outline')) {
                this.mySmartMap.removeLayer(sourceId + '-outline');
            }
        
            const circleFlagLayerId = 'circle-flag-for-' + sourceId;
            if (this.mySmartMap.getLayer(circleFlagLayerId)) {
                this.mySmartMap.removeLayer(circleFlagLayerId);
            }
        
            if (this.mySmartMap.getSource(sourceId)) {
                this.mySmartMap.removeSource(sourceId);
            }
        
            if (route.add_circle_and_flag) {
                if (document.getElementById('start-button-' + sourceId)) {
                    document.getElementById('start-button-' + sourceId).remove();
                }
                if (document.getElementById('end-button-' + sourceId)) {
                    document.getElementById('end-button-' + sourceId).remove();
                }
                if (this.mySmartMap.getLayer(circleFlagLayerId)) {
                    this.mySmartMap.setLayoutProperty(circleFlagLayerId, 'visibility', 'none');
                }
            }
        
            if (this.startMarker) {
                this.startMarker.remove();
                this.startMarker = null;
            }
        
            if (this.endMarker) {
                this.endMarker.remove();
                this.endMarker = null;
            }
        
            if (this.currentPopup) {
                this.currentPopup.remove();
                this.currentPopup = null;
            }
        
            this.mySmartMap.off('zoom', this.updatePopupVisibility);
            this.mySmartMap.off('move', this.updatePopupVisibility);
        
            this.isRouteHidden = true;
        },
    
        updatePopupVisibility() {
            if (this.isRouteHidden) {
                if (this.currentPopup) {
                    this.currentPopup.remove();
                }
                return;
            }
    
            const zoomLevel = this.mySmartMap.getZoom();
    
            if (zoomLevel >= 14) {
                if (this.currentPopup && this.currentPopup.isOpen()) {
                    this.currentPopup.remove();
                }
            } else {
                if (this.currentPopup && !this.currentPopup.isOpen()) {
                    this.currentPopup.addTo(this.mySmartMap);
                }
            }
        }
    }
};